/**
 * =============================================================================
 * QIKIFY GIFT WRAP — CON 2+ UNIDADES O CON ALGÚN PACK — Maminat
 * =============================================================================
 *
 * El checkbox "Envoltorio navideño" del Qikify Slide Cart (opción Gift Wrapping
 * de la app) solo debe verse cuando el carrito tiene 2 o más unidades, o al
 * menos un PACK (aunque sea una sola unidad). No cuentan la línea del propio
 * envoltorio (si no, al marcarlo se sostendría solo) ni las líneas gratis.
 * Funciona igual en es, /en y /pt.
 *
 * CÓMO FUNCIONA
 * -------------
 * - La visibilidad la decide una clase en <html>: `qsc-has-pack`.
 *   El CSS ('qikify-custom-controls.css') oculta `.qsc2-gift-wrapping` mientras
 *   esa clase NO esté. Así sobrevive a los re-renders de Qikify sin vigilarlos.
 * - Estado inicial: lo pone Liquid en 'theme.liquid' leyendo `cart.items`
 *   (cero parpadeo al cargar la página).
 * - Cambios del carrito: un MutationObserver sobre el drawer de Qikify compara
 *   las líneas pintadas (título, cantidad y precio de línea) con las de la última
 *   vez. Solo si cambian (se añadió o quitó un producto, o cambió una cantidad)
 *   se pide UNA vez '/cart.js' y se aplica la regla.
 * - Si el carrito deja de cumplir y el checkbox estaba marcado, se desmarca con un
 *   evento 'change' y Qikify quita SU línea de envoltorio del carrito (la que
 *   lleva la propiedad `_qsc_gift_wrapping`). No borramos nada por nuestra cuenta.
 *
 * QUÉ ES UN PACK
 * --------------
 * Un producto cuyo ID esté en window.__QSC_PACK_IDS, que se define en
 * 'theme.liquid' (única lista). Se usan IDs y no títulos porque las traducciones
 * de los packs en en/pt no siempre dicen "pack".
 *
 * Además: fuerza el texto del checkbox en el idioma de la página y lo coloca bajo
 * la barra de envío gratis. La caja de mensaje (textarea) se oculta por CSS.
 * Y evita que se abra el teclado en mobile con el carrito abierto (ver al final).
 * =============================================================================
 */

(function () {
    'use strict';

    var PACK_IDS = window.__QSC_PACK_IDS || [];
    var LABELS = {
        es: 'Incluir envoltorio navideño en tu pedido',
        en: 'Add Christmas gift wrapping to your order',
        pt: 'Incluir embrulho de Natal na sua encomenda'
    };
    var HAS_PACK_CLASS = 'qsc-has-pack'; // nombre histórico: hoy significa "el carrito cumple"
    var ITEM_SEL = '.qsc2-drawer--product-block .qsc2-product-item';

    // 2+ unidades o algún pack, sin contar el envoltorio ni las líneas gratis
    function qualifies(cart) {
        var units = 0;
        var pack = false;
        cart.items.forEach(function (i) {
            if ((i.properties && i.properties._qsc_gift_wrapping) || i.final_line_price === 0) return;
            units += i.quantity;
            if (PACK_IDS.indexOf(i.product_id) !== -1) pack = true;
        });
        return pack || units > 1;
    }

    var root = document.documentElement;
    var lang = (window.location.pathname.match(/^\/(en|pt)(\/|$)/) || [])[1] || 'es';
    var label = LABELS[lang];

    var hasPack = root.classList.contains(HAS_PACK_CLASS); // estado que dejó Liquid
    var lastSig = '';   // '' = drawer aún sin líneas pintadas: se respeta lo de Liquid
    var seq = 0;        // descarta respuestas de /cart.js que lleguen desordenadas

    function apply(app) {
        root.classList.toggle(HAS_PACK_CLASS, hasPack);

        var box = app.querySelector('.qsc2-gift-wrapping');
        if (!box) return;

        if (!hasPack) {
            var checkbox = box.querySelector('#qsc2-gift-wrapping');
            if (checkbox && checkbox.checked) {
                checkbox.checked = false;
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
        }

        var msg = box.querySelector('.qsc2-gift-wrapping__msg');
        if (msg && msg.textContent !== label) msg.textContent = label;

        var goalBar = app.querySelector('.sc-order-goal');
        if (goalBar && goalBar.parentNode === box.parentNode && goalBar.nextSibling !== box) {
            goalBar.parentNode.insertBefore(box, goalBar.nextSibling);
        }
    }

    function sync(app) {
        var items = app.querySelectorAll(ITEM_SEL);
        var sig = Array.prototype.map.call(items, function (it) {
            var title = it.querySelector('.qsc2-product-item__product-title');
            var qty = it.querySelector('.qsc2-product-item__quantity-input');
            var price = it.querySelector('.qsc2-product-item__line-price');
            return (title ? title.textContent : '') + '×' + (qty ? qty.value : '') + '=' + (price ? price.textContent : '');
        }).join('|');

        if (sig !== lastSig) {
            lastSig = sig;
            var mine = ++seq;
            if (!items.length) {
                hasPack = false; // carrito vacío
            } else {
                fetch('/cart.js', { credentials: 'same-origin' })
                    .then(function (r) { return r.json(); })
                    .then(function (cart) {
                        if (mine !== seq) return;
                        hasPack = qualifies(cart);
                        apply(app);
                    })
                    .catch(function () {});
            }
        }
        apply(app);
    }

    function attach() {
        var app = document.getElementById('qikify-stickycart-v2-app');
        if (!app || !app.querySelector('.qsc2-drawer')) return false;

        // Síncrono dentro del callback: corre antes del siguiente pintado.
        new MutationObserver(function () { sync(app); })
            .observe(app, { childList: true, subtree: true, characterData: true });
        sync(app);
        return true;
    }

    if (!attach()) {
        var finder = setInterval(function () {
            if (attach()) clearInterval(finder);
        }, 500);
    }

    // ─── SIN TECLADO FANTASMA EN MOBILE ─────────────────────────────────────────
    // Al tocar el checkbox en mobile se abría el teclado: el popup de Omnisend,
    // abierto DETRÁS del carrito, le robaba el foco a cada toque para su campo de
    // email. La causa se resuelve en 'qikify-cart-layering.css' (lo oculta con el
    // carrito abierto); esto es la red de seguridad por si otro script lo hace:
    // mientras el carrito está abierto, un campo de texto solo puede tomar el foco
    // si el usuario lo tocó o llegó con el teclado (Tab). Si un foco programático
    // se lo quita a un campo que el usuario sí tocó, se le devuelve (una vez).
    var lastTap = null;
    var viaKeyboard = false;
    var restored = false;

    function isTextField(el) {
        return el && /^(INPUT|TEXTAREA)$/.test(el.tagName) && !/^(checkbox|radio|button|submit)$/.test(el.type);
    }

    document.addEventListener('pointerdown', function (e) {
        lastTap = e.target;
        viaKeyboard = false;
        restored = false;
    }, true);
    document.addEventListener('keydown', function () { viaKeyboard = true; }, true);

    document.addEventListener('focusin', function (e) {
        var t = e.target;
        if (viaKeyboard || !document.body.classList.contains('qsc2-drawer-opened')) return;
        if (!isTextField(t)) return;

        var tappedLabel = lastTap && lastTap.closest && lastTap.closest('label');
        if (lastTap && (t === lastTap || t.contains(lastTap) || (tappedLabel && tappedLabel.control === t))) return;

        t.blur();
        if (!restored && isTextField(lastTap) && lastTap.isConnected) {
            restored = true;
            lastTap.focus();
        }
    }, true);
})();
